import routesGenerator, { UiRoutes } from 'global/lib/routes/routesConfig'

import UI_ROUTES from 'admin/configs/ui_routes'

const routesConfig: UiRoutes = routesGenerator(UI_ROUTES)

export default routesConfig
